import { Stack, Typography } from '@mui/material';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <Stack
      // On a phone the two lines split mid-phrase and sat side by side as a
      // ragged block; stacked and centred reads correctly at any width.
      direction={{ xs: 'column', sm: 'row' }}
      spacing={{ xs: 0, sm: 1 }}
      sx={{
        color: 'rgba(0, 0, 0, 1)',
        fontSize: '16px',
        fontWeight: '400',
        lineHeight: '24px',
        textAlign: { xs: 'center', sm: 'left' },
        alignItems: 'center',
        justifyContent: { xs: 'center', sm: 'flex-start' },
        padding: 2,
      }}
    >
      <Typography>Copyright © {currentYear}, </Typography> <Typography sx={{ color: (theme)=>theme.palette.primary.main }}>Powered by Prism Procure AI Private Limited</Typography>
    </Stack>
  )
}

export default Footer